<template>
  <div>
    <div v-show="!needBind" class="register">
      <p class="title">{{ title }}</p>
      <div class="l-btn google" @click="authGoogle">
        <img src="../../assets/imgs/login-google.png" />
        <span>Continue with Google</span>
      </div>
      <div class="l-btn facebook" @click="authFaceBook">
        <img src="../../assets/imgs/login-facebook.png" />
        <span>Continue with Facebook</span>
      </div>
      <div class="l-btn apple">
        <div
          id="appleid-signin"
          data-color="black"
          data-border="true"
          data-type="continue"
          data-width="336"
          data-height="46"
          data-border-radius="50"
        ></div>
      </div>
      <p class="or">OR</p>
      <div class="login-form">
        <Input v-model="email" class="input" autocomplete="off" label="Email" />
        <Input
          v-model="pasw"
          class="input"
          autocomplete="new-password"
          type="password"
          password
          label="Password"
        ></Input>
        <Input
          v-model="cpasw"
          class="input"
          autocomplete="new-password"
          type="password"
          password
          label="Confirm Password"
        ></Input>
        <p class="privacy-policy">
          By registering, you agree to our
          <a href="https://support.movingkite.com/hc/en-us/articles/4408785752347" target="_blank">Privacy Policy</a>
          and
          <a href="https://support.movingkite.com/hc/en-us/articles/4408794119451" target="_blank">Terms of Service</a>
        </p>
        <div class="login-box">
          <div class="login-msg">
            <span v-if="loginMsg">{{ loginMsg }}</span>
          </div>
          <Button class="login-btn" @click="signup">
            <span>Sign up</span>
          </Button>
        </div>
      </div>
      <div class="login-footer">
        <p>Don’t have an account ?<span class="sign-up" @click="emitLogin">Log in</span></p>
      </div>
      <i-spin v-if="loading" fix>
        <i-icon type="ios-loading" size="40" class="spin-icon-load" />
      </i-spin>
    </div>

    <div v-if="needBind" class="register">
      <div style="width:100%">
        <p class="title-bind">{{ bindEmail }}<br />has already been registered</p>
      </div>
      <p style="margin-top: 10px">
        You can enter the password for that account to link it with your third-party account
      </p>
      <div class="login-form">
        <Input v-model="pasw" class="input" type="password" password label="Password">
          <div slot="right" class="right">
            <span class="btn" @click="forgetPasw">Forget?</span>
          </div>
        </Input>
        <!--      <i-button @click="bindLogin">绑定!!!!!</i-button>-->
        <div class="login-box">
          <Button class="login-btn" @click="bindLogin">
            <span>Confirm to link</span>
          </Button>
          <Button class="login-btn" type="outline" @click="cancelBind">
            <span>Cancel</span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/comm/Nav';
import Input from '../../components/input/Input';
import Button from '../../components/button/Button';
import { mapActions } from 'vuex';
import md5 from 'js-md5';
import API from '../../configs/api.config';
import jsLoader from '@/utils/jsLoader';

export default {
  components: {
    Nav,
    Input,
    Button,
  },
  props: ['title'],
  data() {
    return {
      needBind: false,
      bindEmail: '',
      email: '',
      pasw: '',
      cpasw: '',
      emailValidation: '',
      paswValidation: '',
      loginMsg: '',
      loading: false,
    };
  },
  mounted() {
    this._opener = null;
    this._authKey = '';
    this._timer = -1;
    this._authKey = '';

    jsLoader('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js', 'apple').then(
      () => {
        this.AppleID = window.AppleID;
        this.AppleID.auth.init({
          clientId: 'com.movingkite.loginwithapple',
          scope: 'name email',
          redirectURI: window.location.origin + '/auth/apple.json',
          state: 'Initial user authentication request',
          nonce: 'nonce',
          usePopup: true,
        });
      },
    );

    // Listen for authorization success.
    document.addEventListener('AppleIDSignInOnSuccess', event => {
      // Handle successful response.
      // console.log('AppleIDSignInOnSuccess.event', event);
      // console.log('AppleIDSignInOnSuccess', event.detail.data);
      this.authApple(event);
    });

    // Listen for authorization failures.
    // document.addEventListener('AppleIDSignInOnFailure', event => {
    //   Handle error.
    //   console.log('AppleIDSignInOnFailure', event.detail.error);
    // });
  },
  methods: {
    ...mapActions('register', ['register']),
    ...mapActions('login', ['login']),
    ...mapActions('app', ['checkAppConfig']),
    signup() {
      if (this.loading) {
        return;
      }
      let emailReg = /[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+/;
      this.loginMsg = '';
      if (!emailReg.test(this.email)) {
        return this.$Message.error('email invalid');
      }
      if (this.pasw.length < 6 || this.pasw != this.cpasw) {
        return this.$Message.error('password invalid');
      }
      this.loading = true;
      let body = {
        email: this.email,
        password: md5(this.pasw),
      };
      this.register(body)
        .then(res => {
          if (res.success) {
            {
              //注册成功后自动登录
              let body = {
                username: this.email,
                password: md5(this.pasw),
                authType: 'email',
              };
              this.login({ api: API.login, body: body }).then(res => {
                if (res.success) {
                  this.$emit('login-success');
                } else {
                  this.loginMsg = res.message;
                  if (res.message === 'login failed') this.loginMsg = 'The email or password is incorrect';
                  this.$emit('register-success', this.email, this.pasw);
                }
              });
            }
          } else {
            this.loginMsg = res.message;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    emitLogin() {
      this.$emit('login');
    },
    authGoogle() {
      this.authOther(API.authGoogle, { state: 'blank' });
    },
    authFaceBook() {
      this.authOther(API.authFaceBook, { state: 'blank' });
    },
    authApple(event) {
      this._authKey = 'test';
      const body = {
        nonce: 'test',
        jwt: event.detail.authorization.id_token,
      };
      if (event.detail.user) {
        body.apple_email = event.detail.user.email;
        body.apple_first_email = event.detail.user.name.firstName;
        body.apple_last_email = event.detail.user.name.lastName;
      }
      this.loading = true;
      this.login({ api: API.authApple, body: body })
        .then(res => {
          if (typeof res === 'string' && res.includes('needs to be bound')) {
            this.needBind = true;
            //decode jwt 获取邮箱
            // eslint-disable-next-line no-unused-vars
            const [header, content, sign] = event.detail.authorization.id_token.split('.');
            const contentStr = Buffer.from(content, 'base64').toString();
            const payload = JSON.parse(contentStr);

            this.bindEmail = payload.email;
            this.loading = false;
            return;
          }
          if (res?.success) {
            this.$emit('login-success');
          } else {
            this.loginMsg = res.message;
            if (res.message === 'login failed') this.loginMsg = 'The email or password is incorrect';
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    authOther(api, body) {
      this.loading = true;
      this.$post(api, body)
        .then(res => {
          this.loading = false;
          if (res.success) {
            this._authKey = res.data.match(/state=(\w+)/)[1];
            this.openAuthWindow(res.data);
            this.listenerAuthCheck();
          } else {
            this.$Message.warning(res.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    listenerAuthCheck() {
      if (this._timer) {
        clearTimeout(this._timer);
      }
      try {
        if (!this._opener || this._opener.closed) {
          return this.$Message.warning('Canceled');
        }
      } catch (error) {
        //TODO 跨域错误
      }
      this.$post(API.authCheck, {}, { token: this._authKey }).then(res => {
        if (res.success) {
          if (res.message === 'needs bound existing account') {
            this.needBind = true;
            this.bindEmail = res.data;
            this.closeAuthWindow();
            return;
          }
          this.checkAppConfig();
          this.$emit('login-success');
          this.closeAuthWindow();
        } else {
          if (res.response) {
            if (res.response.status === 401) {
              this.closeAuthWindow();
            } else if (res.response.status === 301) {
              this._timer = setTimeout(() => {
                this.listenerAuthCheck();
              }, 2000);
            }
          } else if (res.message === 'authing') {
            this._timer = setTimeout(() => {
              this.listenerAuthCheck();
            }, 2000);
          } else {
            this.closeAuthWindow();
            this.$Message.error({
              duration: 3,
              content: res.message,
            });
          }
        }
      });
    },
    openAuthWindow(url) {
      let left = (window.outerWidth - 700) / 2,
        top = (window.outerHeight - 700) / 2;
      this._opener = window.open(url, 'auth', `width=700, height=700, left=${left}, top=${top}`);
    },
    closeAuthWindow() {
      if (this._timer) {
        clearTimeout(this._timer);
      }
      if (this._opener) {
        this._opener.close();
        this._opener = null;
      }
    },
    forgetPasw() {
      this.$router.push({
        query: {
          email: this.email,
        },
        path: '/find-password',
      });
    },
    bindLogin() {
      if (this.loading) {
        return;
      }
      this.loginMsg = '';
      if (this.pasw.length < 6) {
        this.loginMsg = 'Invalid password';
        return;
      }
      let body = {
        username: this.bindEmail,
        password: md5(this.pasw),
        authType: 'email',
      };
      this.loading = true;
      this.login({ api: API.login, body: body })
        .then(res => {
          if (res.success) {
            this.bindExistingEmail();
            this.needBind = false;
            this.$emit('login-success');
          } else {
            this.loginMsg = res.message;
            if (res.message === 'login failed') this.loginMsg = 'The email or password is incorrect';
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async bindExistingEmail() {
      await this.$post(API.bindExistingEmail, {}, { token: this._authKey }).then(res => {
        if (res.success) {
          console.log('bindSuccess:', res.data);
        } else {
          console.log('bindError');
        }
      });
    },
    cancelBind() {
      this.bindEmail = '';
      this.pasw = '';
      this.needBind = false;
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.register {
  width: 340px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .title {
    .font-regular;
    font-size: 18px;
    font-weight: 400;
    color: #262626;
    line-height: 24px;
    text-align: center;
  }
  .title-bind {
    .font-regular;
    margin-top: 80px;
    font-size: 18px;
    font-weight: 400;
    color: #262626;
    line-height: 24px;
  }
  .l-btn {
    .font-light;
    width: 336px;
    height: 46px;
    cursor: pointer;
    border-radius: 23px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: #ffffff;
    img {
      width: 20px;
      margin-right: 10px;
    }
    &.google {
      background: #3f7eee;
      margin-top: 26px;
    }
    &.facebook {
      margin-top: 16px;
      background: #3b5897;
    }
    &.apple {
      margin-top: 16px;
    }
  }
  .privacy-policy {
    .font-light;
    padding-top: 10px;
    font-size: 12px;
    font-weight: 300;
    line-height: 15px;
    color: @app-black-color;
    a {
      color: @app-blue-color;
    }
  }
  .or {
    .font-regular;
    width: 80%;
    margin: 26px auto;
    position: relative;
    height: 18px;
    font-size: 14px;
    font-weight: 400;
    color: @app-black-color;
    line-height: 18px;
    text-align: center;
    &::before,
    &::after {
      content: ' ';
      display: inline-block;
      width: 86px;
      height: 1px;
      background-color: #eeeff0;
      position: absolute;
      top: 8.5px;
      left: 0;
    }
    &::after {
      right: 0;
      left: auto;
    }
  }
}
.login-form {
  width: 100%;
  .input {
    .right {
      color: @app-blue-color;
    }
  }
  .login-box {
    margin-top: 36px;
    .login-msg {
      .font-light;
      text-align: center;
      height: 18px;
      font-size: 14px;
      font-weight: 300;
      color: @app-error-color;
      line-height: 18px;
    }
    .login-btn {
      margin-top: 10px;
      //color: #fff;
    }
  }
}
.login-footer {
  .font-light;
  padding-top: 26px;
  height: 18px;
  font-size: 14px;
  font-weight: 300;
  color: @app-black-color;
  line-height: 18px;
  .sign-up {
    color: @app-blue-color;
    padding-left: 6px;
    cursor: pointer;
  }
}
</style>
<style>
.ivu-spin-main {
  color: #fff;
}
</style>
